import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { Observable } from 'rxjs';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { DateService } from 'src/app/utils/date/date.service';

@Injectable({
  providedIn: 'root'
})
export class EmpresaService {
  controller: string = "empresa/";
  controllerParametros: string = "parametro/";

  URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
    private dateService: DateService
  ) { }


  index(body: { filtered: boolean, filters: any[], sorted: boolean, sorted_by: string, sorted_asc: boolean, page: number, pageSize: number, unlimited?: boolean } = { filtered: false, filters: [], sorted: false, sorted_by: '', sorted_asc: true, page: 1, pageSize: 20 }): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + "index", body, this.sesion.headers);
  }

  crearConEmail(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'create-by-email', data, this.sesion.headers);
  }

  create(data: any, user: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'create', { empresa: data, usuario: user }, this.sesion.headers);
  }

  view(id: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "view/" + id, this.sesion.headers);
  }

  update(data: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'update/' + data.id, { empresa: data }, this.sesion.headers);
  }

  activate(data: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'activate/' + data.id, this.sesion.headers);
  }

  deactivate(data: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'deactivate/' + data.id, this.sesion.headers);
  }

  activateSII(id: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controllerParametros + 'activate-sii/' + id, {}, this.sesion.headers);
  }

  deactivateSII(id: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controllerParametros + 'deactivate-sii/' + id, {}, this.sesion.headers);
  }

  settings(id: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controllerParametros + "parametros/" + id, this.sesion.headers);
  }

  updateSettings(clave: string, valor: string): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controllerParametros + "update-config/", { clave, valor }, this.sesion.headers);
  }

  getFonoEmpresa(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "get-phone", this.sesion.headers);
  }

  updateMiEmpresa(data: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'update-mi-empresa', data, this.sesion.headers);
  }

  ampliarPrueba(id: any, tipoPlan: any = 0) {
    return this.http.put(this.config.apiUrl + this.controller + "ampliar-prueba/" + id, { tipoPlan }, this.sesion.headers);
  }

  finalizarPrueba(id: any) {
    return this.http.put(this.config.apiUrl + this.controller + "finalizar-prueba/" + id, {}, this.sesion.headers);
  }

  cambiarPlanEmpresa(empresa_id: number, tipo: number) {
    return this.http.put(this.config.apiUrl + this.controller + `cambiar-plan/${empresa_id}`, { tipo }, this.sesion.headers);
  }

  getLogo(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'get-logo/', this.sesion.headersBlob);
  }
  selectEmpresas(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + 'select-empresas/', this.sesion.headers);
  }

  obtenerLabelPlan(plan_id: number, tipo_suscripcion: number) {
    let plan = '';
    let vencida = false;
    switch (plan_id) {
      case 1: plan = 'Filtro X'; break;
      case 2: plan = 'Acelera+'; break;
      case 3: plan = 'Turbo'; break;
      case 4: plan = 'Filtro X'; break;
      case 5: plan = 'Acelera+'; break;
      case 6: plan = 'Turbo'; break;
      default: plan = 'Prueba'; break;
    }
    switch (tipo_suscripcion) {
      case 3: plan += ' - Mensual'; break;
      case 4: plan += ' - Anual'; break;
      default: break;
    }
    if (tipo_suscripcion == 0) {
      plan = 'Prueba'
    }
    return plan;
  }

  empresaToEvento(empresa: any) {
    const evento: any = {}

    let color = '#198754';
    if (new Date(empresa.proximo_pago) < new Date()) {
      color = '#DC3545';
    }
    if (empresa.tipo_suscripcion == 0) {
      color = '#2563FD';
      if (new Date(empresa.proximo_pago) < new Date()) {
        color = '#C31770';
      }
    }

    evento.id = empresa.id;
    evento.title = `${empresa.nombre} - ${this.obtenerLabelPlan(empresa.plan_id, empresa.tipo_suscripcion)}`;
    evento.start = this.dateService.formatUtcString(empresa.proximo_pago);
    evento.end = this.dateService.formatUtcString(this.dateService.format(this.dateService.addTime('+30 minutes', new Date(empresa.proximo_pago))));
    evento.backgroundColor = color;
    evento.borderColor = color;
    evento.textColor = 'white';
    return evento;
  }

  empresasPorRegion(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `empresas-por-region`, this.sesion.headers);
  }

  descargarLogos(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `descargar-logos`, { ...this.sesion.headersBlob });
  }

  getIframeUrl(): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `iframe-url`, this.sesion.headers);
  }

  getInfoEmpresaDesdeTokenParaAnonimo(empresaPublicToken: string): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + `get-info-empresa-desde-token-para-anonimo/${empresaPublicToken}`, this.sesion.headersAnonimo);
  }

  vincularSuscripcion(data: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + `vincular-suscripcion`, data, this.sesion.headers);
  }
  guardarFormulario(data: any, certificado: any): Observable<any> {
    const formData = new FormData();
    formData.append('certificado', certificado);
    formData.append('data', JSON.stringify(data));
    return this.http.post(this.config.apiUrl + this.controller + `guardar-formulario`, formData, this.sesion.headersFile);
  }
  activarSolicitudesDatos(empresa_id: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + `activar-solicitudes-datos`, { empresa_id }, this.sesion.headers);
  }

  desactivarSolicitudesDatos(empresa_id: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + `desactivar-solicitudes-datos`, { empresa_id }, this.sesion.headers);
  }
}
